import i18n from '../../../common/i18n';
import React from 'react';
import clsx from 'clsx';

export function FooterMediaServiceStatement({ href, className }: { href: string; className? }) {
    return (
        <a
            className={clsx('mb-20 mt-20 flex-inline text-center fs-14 justify-center full-width ', className)}
            href={href}
            data-atid={'footer-media_services_statement'}
        >
            <span>{i18n('nui.footer.media_services_statement')}</span>
        </a>
    );
}
